import { gql } from '@apollo/client'

export const TESTS_RESULTS_ANALYTICS = gql`
  query TestsResultsAnalyticsLazy(
    $filterData: TestsResultsAnalyticsInput
    $pagination: PaginationInput!
  ) {
    testsResultsAnalytics(filterData: $filterData, pagination: $pagination) {
      tests {
        id
        barcode
        testedAt
        result
        secondResult
        resultProvisionedAt
        resultVerifiedAt
        specimenType
        User {
          id
          firstName
          lastName
          birthDate
          email
          phoneNumber
          gender
          race
          ethnicity
          Address {
            street
            complement
            city
            state
            zip
            country
          }
        }
        TestSession {
          id
          date
          name
          lab
          type
          customTestType {
            name
          }
          paymentStatus
          finishedAt
          invoiceId
          invoiceDocNumber
          Company {
            id
            name
          }
          zip
        }
        eventId
        eventpaymentMethod
        Insurance {
          id
          insuranceCompany
        }
        Group {
          name
        }
        Company {
          name
        }
      }
      pagination {
        from
        length
        total
      }
    }
  }
`
